
import { Component, Vue } from 'vue-property-decorator'
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateShiftTypeForm } from '@/services/Calendar/ShiftType/forms/CreateShiftTypeForm';
import ShiftTypeRepository from '@/services/Calendar/ShiftType';

@Component({
  inject: [
    'shiftTypeRepository',
  ],
  computed: {
    swatchTextColorStyle(): unknown {
      return {
        // @ts-ignore
        backgroundColor: this.form.data.textColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        border: '1px solid black',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    swatchBackgroundStyle(): unknown {
      return {
        // @ts-ignore
        backgroundColor: this.form.data.background,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        border: '1px solid black',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },
})
export default class CreateShiftType extends Vue {
  private readonly shiftTypeRepository!: ShiftTypeRepository;

  private loading: boolean = true;
  private startAtMenu: boolean = false;
  private endAtMenu: boolean = false;
  private breakDuration: Array<{ value: number, text: string }> = [{
    value: 30,
    text: 'Half hour',
  }, {
    value: 60,
    text: 'Hour',
  }];
  private textColorMenu: boolean = false;
  private backgroundMenu: boolean = false;
  private dayType: Array<{ value: string, text: string }> = [{
    value: 'work',
    text: 'Normal Work Day',
  }, {
    value: 'paid',
    text: 'Paid leave',
  }, {
    value: 'unpaid',
    text: 'Unpaid leave',
  }, {
    value: 'sick',
    text: 'Sick leave',
  }, {
    value: 'additional_paid',
    text: 'Additional company paid leave',
  }, {
    value: 'marriage',
    text: 'Leave for marriage',
  }, {
    value: 'blood_donation',
    text: 'Leave for blood donation',
  }, {
    value: 'funeral',
    text: 'Leave for funeral',
  }, {
    value: 'paternity',
    text: 'Paternity leave',
  }, {
    value: 'other',
    text: 'Other',
  }];

  private form: WPXFormValue<CreateShiftTypeForm> = new WPXFormValue(CreateShiftTypeForm);

  private async created(): Promise<void> {
    this.loading = false;
    this.form.data.breakDuration = 60;
  }

  private async createShiftType(): Promise<void> {
    try {
      await this.shiftTypeRepository.createShiftType({
        name: this.form.data.name,
        shortName: this.form.data.shortName,
        duration: Number(this.form.data.duration),
        breakDuration: Number(this.form.data.breakDuration),
        startAt: this.form.data.startAt,
        endAt: this.form.data.endAt,
        textColor: this.form.data.textColor,
        background: this.form.data.background,
        dayType: this.form.data.dayType,
        automations: this.form.data.automations,
      })

      this.$successDialog.show(`Shift Type '${this.form.data.name}' has been created.`);

      this.formReset();
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }

  private formReset(): void {
    this.form.data.name = '';
    this.form.data.shortName = '';
    this.form.data.startAt = '';
    this.form.data.endAt = '';
    this.form.data.duration = 0;
  }

  private calculateShiftDuration(): void {
    this.form.data.duration = this.shiftTypeRepository.calculateShiftDuration(
      this.form.data.startAt,
      this.form.data.endAt,
      this.form.data.breakDuration,
    );
  }
}
